import React from "react";

const DevLog1 = React.forwardRef((props, ref) => {
  const heading = "Hello!";
  const date = "18th November 2021";

  return (
    <div ref={ref}>
      {/* // ! Do not change positions */}
      <h1>{heading}</h1>
      <h4>{date}</h4>
      <div>
        <p>
          <strong>Welcome to our Dev Log section!</strong>
        </p>

        <p>
          <br />
          As of now, we&#39;re nearing a stable state in our alpha, and
          we&#39;ll be regularly posting updates here moving forward, featuring
          sneak peeks at the development state, News, Assets, and other media.
          Make sure to follow our Twitter account for updates to the Devlog and
          more!
          <br />
          <br />- Particle Interactive
        </p>
      </div>
    </div>
  );
});

export default DevLog1;
